module.exports = __webpack_public_path__ + "img/plus.105c5de1.svg";